export const datenschutzUrl = "https://www.dmb-rechtsschutz.de/datenschutz/";
export const verbraucherschutzUrl = "https://www.dmb-rechtsschutz.de/ueber-uns/verbraucherschutz/";
export const impressumUrl = "https://www.dmb-rechtsschutz.de/impressum/";
